$(document).ready(function () {
    // ----------- Footer Margin Bottom -----------
    function setFooterMargin() {
        var stickyHeight = $('.bottom_sticky_wrapper').outerHeight() || 0;
        $('.footer_wrapper').css('margin-bottom', $('.bottom_sticky_wrapper').is(':visible') ? stickyHeight : 'unset');
    }
    setFooterMargin();

    // ----------- When show add to cart button in product info than hide bottom Navigation bar -----------
function checkVisibility() {
    var $addBox = $(".add_product_wrapper");
    var $sticky = $(".bottom_sticky_wrapper");

    if (!$addBox.length || !$sticky.length) return;

    var viewTop = $(window).scrollTop();
    var viewBottom = viewTop + $(window).height();
    var boxTop = $addBox.offset().top;
    var boxBottom = boxTop + $addBox.outerHeight();
    var isVisible = boxBottom > viewTop && boxTop < viewBottom;

    if (isVisible) {
        if ($sticky.is(":visible")) {
            $sticky.stop().slideUp(300);
        }
    } else {
        if (!$sticky.is(":visible")) {
            $sticky.stop().slideDown(300);
        }
    }
}
    $(window).on('scroll', checkVisibility);
    checkVisibility();

    // ------------ Swiper Fancy box ------------ 
    $('[data-fb-trigger]').on('click', (el) => {
        $(`[data-fb-target="${productImg1.activeIndex}"]`).click();
    });
    // ------------ Start: Bottom Sticky Bar ------------
    $('.variant_weight_btn').on('click', function (event) {
        event.stopPropagation();
        $('.variant_list_box').fadeToggle();
        $('.variant_weight_btn svg').toggleClass('rotate_180');
        $(document).off('click.variantBox').on('click.variantBox', function (event) {
            if (!$(event.target).closest('.variant_weight_btn, .variant_list_box').length) {
                closeVariantBox();
            }
        });
    });
    function closeVariantBox() {
        $('.variant_list_box').fadeOut();
        $('.variant_weight_btn svg').removeClass('rotate_180');
    }
    $(window).on('scroll', function () {
        if ($('.variant_list_box').is(':visible')) {
            closeVariantBox();
        }
    });
    // ------------ End: Bottom Sticky Bar ------------

    // ----------- Variant Option -----------
    $('[data-mn-variants]').on('change', (el) => {
        let variant_str = '';
        $('[data-mn-variants]:checked').each((i, el) => {
            variant_str += el.dataset.variantTitle;
            if ($('[data-mn-variants]:checked').length != i + 1) {
                variant_str += '/';
            }
        });
        $('[name="variant-select"] > option[data-variant-title="' + variant_str + '"]').prop('selected', true);
        let selected_option = $('[name="id"] > option[data-variant-title="' + variant_str + '"]');
        selected_option.prop('selected', true);
        if(!selected_option.data('available')){
            $('.shopify-product-form #add_to_cart_btn').prop('disabled',true);
            document.querySelectorAll('[sw-product-id]').forEach(el => el.setAttribute('disabled',''));
        }
        else{
            $('.shopify-product-form #add_to_cart_btn').prop('disabled',false);
            document.querySelectorAll('[sw-product-id]').forEach(el => el.removeAttribute('disabled'));
        }
        $('[sw-product-details] .price').html(Shopify.formatMoney(selected_option.data('price')));
        if(selected_option.data('compare') == undefined || selected_option.data('compare') == ''){
            $('[sw-product-details] .price_compare').hide();
            $('[sw-product-details] .discount_label').hide();
        }else{
            $('[sw-product-details] .price_compare').html(Shopify.formatMoney(selected_option.data('compare'))).show();
            $('[sw-product-details] .discount_label').html('Get '+parseInt(100-(( selected_option.data('price') * 100 )/selected_option.data('compare')))+'% off').show();
        }
        const event = new CustomEvent('variant:changed', { detail: selected_option });
        document.dispatchEvent(event);
    });

// add to cart Event
$(document).on('click', '[sw-product-id]', function (event) {
    event.preventDefault();

    const button = event.currentTarget;

    if (!button || button.hasAttribute('disabled')) return;

    $(button).children('p').addClass('d_none_imp');
    $(button).children('.loader').addClass('active');

    setTimeout(() => {
        let id = parseInt($('.shopify-product-form [name="id"]').val(), 10);
        let quantity = 1;

        if (button.classList && button.classList.contains('sticky_product')) {
            quantity = parseInt($(button).parent().find('[name="quantity"]').val(), 10) || 1;
        } else {
            quantity = parseInt($('.shopify-product-form [name="quantity"]').val(), 10) || 1;
        }

        if (!id || isNaN(id)) {
            console.error('Variant ID missing. Add to cart stopped.');
            $(button).children('p').removeClass('d_none_imp');
            $(button).children('.loader').removeClass('active');
            return;
        }

        if (typeof swAddToCart === 'function') {
            swAddToCart(id, quantity);
        } else {
            console.error('swAddToCart function not found.');
        }

        $(button).children('p').removeClass('d_none_imp');
        $(button).children('.loader').removeClass('active');

    }, 500);
});
    // ----------- Description accordion -----------
    $(".product_desc_wrapper button").click(function () {
        var $box = $(this).next(".product_desc_box");
        var isOpen = $box.is(":visible");
        if (isOpen) {
            return;
        }
        $(".product_desc_box").slideUp();
        $(".plus").removeClass("d_none");
        $(".minus").addClass("d_none");
        $box.slideDown();
        $(this).find(".plus, .minus").toggleClass("d_none");
    });

    var productImg2 = new Swiper(".productThumb", {
        spaceBetween: 10,
        slidesPerView: 4,
        direction: "horizontal",
        mousewheel: true,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            470: {
                spaceBetween: 15,
            },
            1025: {
                direction: "vertical",
                spaceBetween: 10,
                slidesPerView: 'auto',
            },
            1200: {
                direction: "vertical",
                spaceBetween: 15,
                slidesPerView: 'auto',
            },
        },
    });

    var productImg1 = new Swiper('.productImage', {
        slidesPerView: 1,
        spaceBetween: 15,
        speed: 500,
        loop: true,
        freeMode: false,
        navigation: {
            nextEl: ".productImage_button_next",
            prevEl: ".productImage_button_prev",
        },
        thumbs: {
            swiper: productImg2,
        }
    });
});